import React, {useEffect, useState} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card, Col, Row, Spin, Image, Grid, Collapse, Tooltip, message, Typography} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {fetchCardsListAction, fetchPsychoCardsListAction, fetchSetLikeAction, ROUTE_PATH, selectStore} from "../../../../utils";
import {MySegmented,MyText} from "../../../../components";
import {CaretRightOutlined, LeftOutlined, CopyOutlined, WhatsAppOutlined, SendOutlined, HeartFilled, HeartOutlined } from "@ant-design/icons";
import { useLang } from "../../../../utils/context/lang";
import { PageName, ButtonContainer, ThemeCollapse, StyledCard, StyledImageWrapper } from "../../style";
import { useTranslation } from "react-i18next";
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import { fetchArticleList } from "../../../../api";
import { Helmet } from "react-helmet";
import { Cookies } from "react-cookie";
import { COOKIE_KEY } from "../../../../utils";

export const CurrentCategoryPsychoPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [article, setArticle] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const {t} = useTranslation("common")
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const cookies = new Cookies()
  const age = searchParams.get("age");
  // const {gameCategory} = useParams();
  let fromAge = "";
  let toAge = "";

  if (age) {
    [fromAge, toAge] = age.split('-');
  }
  const isMobile = screens.xs;
  const { Panel } = Collapse;
  const { type, supportId,categoryId } = useParams<{ type: any; supportId: any; categoryId: any }>();
  const [themes, setThemes] = useState<any[]>([
    { id: 1, name: "Холерик" },
    { id: 2, name: "Меланхолик" },
    { id: 3, name: "Сангвиник" },
    { id: 4, name: "Флегматик" }
  ]);
  const [isThemesModalVisible, setIsThemesModalVisible] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [likedArticles, setLikedArticles] = useState<{ [key: number]: boolean }>({});
  const [likeCounts, setLikeCounts] = useState<{ [key: number]: number }>({});
  const [loading, setLoading] = useState(true);
  const { Link } = Typography;
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const {handleChangeLang, lang} = useLang()
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  const psychoCardsList = useSelector((state: any) => state.articles?.psychoCardsList ?? { data: [], loading: false });

// const toggleLike = (articleId: number) => {
//     setLikedArticles((prev) => ({
//       ...prev,
//       [articleId]: !prev[articleId],
//     }));

//     setLikeCounts((prev) => ({
//       ...prev,
//       [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
//     }));
    
//     fetchSetLike(articleId, 'article');
// };

const toggleLike = (articleId: number) => {
  setLikedArticles((prev) => ({
    ...prev,
    [articleId]: !prev[articleId],
  }));
  setLikeCounts((prev) => ({
    ...prev,
    [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
  }));
  dispatch(fetchSetLikeAction({ entity_id: articleId, entity_type: 'article' }));
};

 const formatDate = (dateString, lang) => {
    const date = new Date(dateString);
    const locale = lang === 'kk' ? 'kk-KZ' : 'ru-RU';
  
    const kazakhMonths = [
      'қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым',
      'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан'
    ];
  
    const optionsDate = { year: 'numeric', month: 'long', day: 'numeric' };
    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false, hourCycle: 'h23' };
  
    let formattedDate = new Intl.DateTimeFormat(locale, optionsDate).format(date);
    const formattedTime = new Intl.DateTimeFormat(locale, optionsTime).format(date);
  
    if (lang === 'kk') {
      const monthIndex = date.getMonth();
      const kazakhMonth = kazakhMonths[monthIndex];
      
      formattedDate = formattedDate.replace(
        /(\d{1,2})\s[\wа-яё]+\s(\d{4})/i, 
        `$1 ${kazakhMonth} $2`
      );
    }
  
    return `${formattedDate} ${formattedTime}`.replace(/г\.\s*/, '');
  };

  const handleCopy = () => {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      message.success('Ссылка скопирована');
    } catch {
      message.error('Не удалось скопировать');
    }
  };

  const handleGoBack = () => {
    const path = {
          pathname: generatePath(ROUTE_PATH.CURRENT_PSYCHO, {  type: type, supportId: supportId }),
        };
    embeddedNavigate(path);
  }

  // useEffect(() => {
  //   const fetchContent = async () => {
  //     try {
  //       const response = await fetchPsychoCardsList();
  
  //       setThemes(response);
  //     } catch (error) {
  //       console.error('Error fetching themes:', error);
  //     }
  //   };
  
  //   fetchContent();
  // }, []);

  useEffect(() => {
    dispatch(fetchPsychoCardsListAction({}));
  }, []);

  useEffect(() => {
    if (!psychoCardsList.success || !psychoCardsList.data) return;
    setThemes(psychoCardsList.data);
  }, [psychoCardsList.success, psychoCardsList.data]);

  useEffect(() => {
      const fetchContent = async () => {
        setLoading(true);
        try {
           const response = await fetchArticleList(null, null, null, null, categoryId);
           setArticle(response.list[0]);
        } catch (error) {
          console.error('Error fetching article:', error);
        } finally {
          setLoading(false);
        }
      };
  
      if (supportId) {
        fetchContent();
      }
    }, []);

  const currentItem = themes.find(item => item.id === Number(categoryId));
  const currentTitle = currentItem ? currentItem.name : "";

  return (
    <>
          <Helmet>
            <title>Познавательные детские карточки</title>
            <meta name="description" content="Познавательные видео для обучения детей: речь, внимание, окружающий мир. Весёлые и полезные материалы для изучения дома и в детском саду." />
          </Helmet>


      <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 30}}>
           {screens.xs ? (
              <>
                <Col span={3}>
                  <ButtonContainer onClick={handleGoBack}>
                    <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                  </ButtonContainer>
                </Col>
                <Col span={21}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={24}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    {t("psychoPedSupport")}
                  </MyText>
                </Col>
              </>
            ) : (
              <>
                <ButtonContainer onClick={handleGoBack}>
                  <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                </ButtonContainer>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={32}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                >
                  {currentTitle}
                </MyText>
              </>
            )}
        </Row>
        
      </Col>

      <Col span={20}>
                        <StyledCard style={{ borderRadius: '20px' }}>
                        <PageName>

                        <div style={{ gap: '24px', flexWrap: 'wrap' }}>
                    {loading ? null : (
                        <div style={{
                        display: 'flex',
                        marginTop: '24px',
                        width: '100%',
                        flexDirection: 'row',
                        }}>
                        {article?.image && (
                            <div style={{
                            width: '100%',
                            height: (screens.xs || isTablet) ? 'auto' : '500px',
                            borderRadius: '12px',
                            overflow: 'hidden'
                            }}>
                            <img
                                src={article.image} 
                                alt="Article"
                                style={{
                                width: '100%',
                                height: (screens.xs || isTablet) ? 'auto' : '500px',
                                // height: '100%',
                                objectFit: 'cover'
                                }}
                            />
                            </div>
                        )}
                        </div>
                    )}
                    </div>
                                    <Col span={24} style={{marginTop: 20, padding: "0px !important"}}>
                            <MyText color='#0A033C' size={20} style={{ fontFamily: 'Nunito' }}>
                            <div
                            style={{
                              fontFamily: 'Nunito',
                              lineHeight: '26px',
                              fontSize: screens.xs ? '18px' : '20px',
                            }}
                            dangerouslySetInnerHTML={{
                              __html: article?.content
                                ?.replace(
                                  /<p([^>]*)>/gi,
                                  '<p$1 style="margin-bottom:0.2em;">'
                                )
                                .replace(
                                  /<iframe([^>]*?)style="([^"]*)"([^>]*)>/gi,
                                  '<iframe$1style="$2; width:100%;"$3>'
                                )
                                .replace(
                                  /<iframe([^>]*)>/gi,
                                  '<iframe$1 style="width:100%;">'
                                ),
                            }}
                          />
                            </MyText>
                    </Col>

                    <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: screens.xs ? 0 : 12 }}>
            <Col>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    {article && (likedArticles[article.id] ?? article.is_liked_by_user) ? (
                    <HeartFilled
                        style={{
                        fontSize: 16,
                        color: 'rgba(253, 99, 99, 1)',
                        cursor: 'pointer',
                        }}
                        onClick={token ? () => toggleLike(article.id) : undefined}
                    />
                    ) : (
                    <HeartOutlined
                        style={{
                        fontSize: 16,
                        color: 'rgba(104, 114, 125, 1)',
                        cursor: 'pointer',
                        }}
                        onClick={token ? () => toggleLike(article.id) : undefined}
                    />
                    )}
                    {article && likeCounts[article.id] > 0 && (
                    <MyText color="rgba(104, 114, 125, 1)" size={16} lineHeight="24px">
                        {likeCounts[article.id]}
                    </MyText>
                    )}
                </div>

                {article?.created_at && (
                    <MyText color="rgba(104, 114, 125, 1)" size={16}>
                    {formatDate(article.created_at, lang)}
                    </MyText>
                )}
                </div>
            </Col>

            <Col style={{marginTop: screens.xs ? 6 : 0}}>
            <Row gutter={12} align="middle">
            <Col>
                <MyText color="#0A033C" size={16} weight={600} style={{ fontFamily: 'Nunito' }}>
                {t("share")}:
                </MyText>
            </Col>

            <Col>
                <Tooltip title="Telegram" mouseEnterDelay={0.3} mouseLeaveDelay={0.1}>
                <Link
                    href={`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <SendOutlined style={{ fontSize: 18, color: '#0088cc' }} />
                </Link>
                </Tooltip>
            </Col>

            <Col>
                <Tooltip title="WhatsApp" mouseEnterDelay={0.3} mouseLeaveDelay={0.1}>
                <Link
                    href={`https://api.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <WhatsAppOutlined style={{ fontSize: 18, color: '#25D366' }} />
                </Link>
                </Tooltip>
            </Col>

            <Col>
                <Tooltip title="Скопировать ссылку" mouseEnterDelay={0.3} mouseLeaveDelay={0.1}>
                <span onClick={handleCopy} style={{ cursor: 'pointer' }} tabIndex={-1}>
                    <CopyOutlined style={{ fontSize: 18, color: '#6c757d' }} />
                </span>
                </Tooltip>
            </Col>
            </Row>
            </Col>
            </Row>

                        
                        </PageName>
                    </StyledCard>
                    </Col>
    </Row>

        </Row>
  </>

  )
}